import { useState, useContext } from "react"
import Header from "../../../layouts/Header"
import BackIcon from "../../../components/BackIcon"
import { useNavigate } from "react-router-dom"
import { Box, Paper, TextField, Tooltip, IconButton, Grid, Typography, MenuItem, Divider, Button } from "@mui/material"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { useMutation, api, showWarning } from "../../../api"
import { GlobalContext } from "../../../contexts/GlobalContext"
import getIconComponent from "../../utils/getIconComponent"

const theme = createTheme({ palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" } } })

// Props añadidos para soportar modo Modal
const CrearProveedoresCreaRapi = ({ isModal = false, onClose, onProveedorCreado }) => {
  const navigate = useNavigate()
  const { selectedMenuInfo } = useContext(GlobalContext)
  const [formData, setFormData] = useState({
    procalif: "R",
    proruc: "",
    pronombre: "",
    pronommat: "",
    prodirec: "",
    proemail: "",
    protelef1: "",
    procelu: "",
    prostatus: "A",
  })

  const StyledRoot = {
    width: "100%",
    maxWidth: "1100px",
    margin: "0 auto",
    padding: isModal ? "0px" : "20px",
    backgroundColor: isModal ? "transparent" : "#f5f7fa",
    borderRadius: "12px",
  }

  const { mutateAsync: SaveCreacion, isPending: isSaving } = useMutation({
    queryKey: ["isCreatingProveedorDF"],
    fn: async (data) => (await api.post("/Pesajes/createProveedoresCreaRapi", data)).data,
    showError: "modal",
    showSuccess: "toast",
    onSuccess: (res) => {
      // Si es modal, devolvemos el código generado para autoseleccionarlo, caso contrario navegamos atrás
      if (isModal && onProveedorCreado) {
        onProveedorCreado(res.procodigo)
      } else {
        navigate(-1)
      }
    },
  })

  const handleSubmit = async (e) => {
    if (e) e.preventDefault()
    if (formData.procalif === "R" && formData.proruc.length !== 13)
      return showWarning("El R.U.C. debe tener 13 dígitos")
    if (formData.procalif === "C" && formData.proruc.length !== 10)
      return showWarning("La Cédula debe tener 10 dígitos")
    if (!formData.pronombre.trim() || !formData.prodirec.trim())
      return showWarning("Nombre y Dirección son obligatorios")

    try {
      await SaveCreacion(formData)
    } catch (error) {}
  }

  const action = selectedMenuInfo?.data?.barraAcciones?.find((a) => a.acccaption === "GRABAR")

  const content = (
    <>
      {/* Botonera superior adaptable */}
      <Box sx={{ mb: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Box>
          {action && !isModal && (
            <Tooltip title={action.acccaption}>
              <IconButton
                onClick={handleSubmit}
                disabled={isSaving}
                sx={{ border: "1px solid #ddd", bgcolor: "white" }}
              >
                {getIconComponent(action.accnameicono, action.acctipoico)}
              </IconButton>
            </Tooltip>
          )}
        </Box>
        {isModal && (
          <Button variant="contained" color="error" onClick={onClose}>
            Cerrar
          </Button>
        )}
      </Box>

      <div style={{ display: "flex", justifyContent: "center", mb: "30px", fontSize: "25px", color: "#196C87" }}>
        <b>Nuevo Proveedor (Código Automático)</b>
      </div>

      <CustomBackdrop isLoading={isSaving} />

      <Box sx={StyledRoot}>
        <Paper elevation={isModal ? 0 : 3} sx={{ p: isModal ? 2 : 4, borderRadius: 3, border: isModal ? "none" : "" }}>
          <Typography variant="h6" color="primary">
            Identificación
          </Typography>
          <Divider sx={{ mb: 3 }} />
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <TextField
                select
                fullWidth
                label="Tipo"
                value={formData.procalif}
                onChange={(e) => setFormData({ ...formData, procalif: e.target.value, proruc: "" })}
              >
                <MenuItem value="R">R.U.C.</MenuItem>
                <MenuItem value="C">CÉDULA</MenuItem>
                <MenuItem value="P">PASAPORTE</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                label="Cédula / R.U.C. *"
                value={formData.proruc}
                onChange={(e) => setFormData({ ...formData, proruc: e.target.value.replace(/\D/g, "") })}
                inputProps={{ maxLength: formData.procalif === "R" ? 13 : 10 }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Nombre Comercial *"
                value={formData.pronombre}
                onChange={(e) => setFormData({ ...formData, pronombre: e.target.value.toUpperCase() })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Razón Social"
                value={formData.pronommat}
                onChange={(e) => setFormData({ ...formData, pronommat: e.target.value.toUpperCase() })}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Dirección *"
                value={formData.prodirec}
                onChange={(e) => setFormData({ ...formData, prodirec: e.target.value.toUpperCase() })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Email"
                value={formData.proemail}
                onChange={(e) => setFormData({ ...formData, proemail: e.target.value.toLowerCase() })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Celular"
                value={formData.procelu}
                onChange={(e) => setFormData({ ...formData, procelu: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                select
                fullWidth
                label="Estado"
                value={formData.prostatus}
                onChange={(e) => setFormData({ ...formData, prostatus: e.target.value })}
              >
                <MenuItem value="A">ACTIVO</MenuItem>
                <MenuItem value="I">INACTIVO</MenuItem>
              </TextField>
            </Grid>
          </Grid>

          {/* Botón de guardar gigante si es modal */}
          {isModal && (
            <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
              <Button variant="contained" color="primary" size="large" onClick={handleSubmit} disabled={isSaving}>
                GUARDAR PROVEEDOR
              </Button>
            </Box>
          )}
        </Paper>
      </Box>
    </>
  )

  // Si es modal, renderizamos solo el contenido sin ThemeProvider ni Header
  if (isModal) {
    return <Box sx={{ p: 2 }}>{content}</Box>
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        {content}
      </div>
    </ThemeProvider>
  )
}

export default CrearProveedoresCreaRapi
